/* eslint-disable import/no-commonjs */
// This file is used exclusively within getEnvironment.js, hence the use of the commonjs export

// Used within the MTG Renewal Appointment Booking application.
// This is so in the future we can easily extend this functionality to include regional numbers, if call volumne increases.

const MTG_AGENTS_CALL_NOW_NUMBERS = {
    DEFAULT: '1-866-988-6324',
};

module.exports = MTG_AGENTS_CALL_NOW_NUMBERS;
